module.exports = {
    ASSET_ALLOCATION_SELECTED: 'AssetAllocation/SELECTED',
    COUNTRY_EXPOSURE_SELECTED: 'InvestmentFunds/CountryExposure/SELECTED',
    FETCH_PROFILE_SUCCESS: 'FETCH_PROFILE_SUCCESS',
    FUNDBOX_OPENED: 'InvestmentFunds/FUNDBOX_OPENED',
    FUNDBOX_CLOSED: 'InvestmentFunds/FUNDBOX_CLOSED',
    FUNDS_FETCH_FAILED: 'InvestmentFunds/FETCH_FAILED',
    FUNDS_FETCH_REQUESTED: 'InvestmentFunds/FETCH_REQUESTED',
    FUNDS_FETCH_SUCCEEDED: 'InvestmentFunds/FETCH_SUCCEEDED',
    GLOBAL_STOCK_SELECTED: 'InvestmentFunds/GlobalStock/SELECTED',
    GLOSSARY_CLOSED: 'GLOSSARY_CLOSED',
    GLOSSARY_LETTER_SELECTED: 'GLOSSARY_LETTER_SELECTED',
    GLOSSARY_OPENED: 'GLOSSARY_OPENED',
    GLOSSARY_QUERY_CHANGED: 'GLOSSARY_QUERY_CHANGED',
    GLOSSARY_RESULT_CLOSED: 'GLOSSARY_RESULT_CLOSED',
    GLOSSARY_RESULT_SELECTED: 'GLOSSARY_RESULT_SELECTED',
    GROWTH_AMOUNT_CHANGED: 'InvestmentFundsView/Growth/AMOUNT_CHANGED',
    GROWTH_PERIOD_CHANGED: 'InvestmentFundsView/Growth/PERIOD_CHANGED',
    MARKET_CAPITAL_BREAKDOWN_SELECTED:
        'InvestmentFundsView/marketCapitalBreakdown/SELECTED',
    PROFITABILITY_RANGE_SELECTED:
        'InvestmentFundsView/Profitability/RANGE_SELECTED',
    PROFIT_RISK_OPTION_SELECTED:
        'InvestmentFundsView/ProfitRisk/OPTION_SELECTED',
    TAB_SWITCHED: 'InvestmentFundsView/Tabs/SWITCHED',
    FUNDS_FETCH_SUB_CATEGORIES:
        'InvestmentFundsView/FUNDS_FETCH_SUB_CATEGORIES',
    FUNDS_FETCH_MINIMUN_DETAILS:
        'InvestmentFundsView/FUNDS_FETCH_MINIMUN_DETAILS',
    TRANSLATIONS_REQUEST_FAILURE: 'TRANSLATIONS_REQUEST_FAILURE',
    TRANSLATIONS_REQUEST_SUCCESS: 'TRANSLATIONS_REQUEST_SUCCESS',
    TRANSLATIONS_FETCH_REQUEST: 'TRANSLATIONS_FETCH_REQUEST',
    GLOBAL_VARIABLES_FAILURE: 'GLOBAL_VARIABLES_FAILURE',
    GLOBAL_VARIABLES_REQUEST: 'GLOBAL_VARIABLES_REQUEST',
    GLOBAL_VARIABLES_SUCCESS: 'GLOBAL_VARIABLES_SUCCESS',
    BROKER_ADVANCED_SEARCH_RESULTS_CLEAR:
        'BROKER_ADVANCED_SEARCH_RESULTS_CLEAR',
    BROKER_ADVANCED_SEARCH_RESULTS_FAILURE:
        'BROKER_ADVANCED_SEARCH_RESULTS_FAILURE',
    BROKER_ADVANCED_SEARCH_RESULTS_REQUEST:
        'BROKER_ADVANCED_SEARCH_RESULTS_REQUEST',
    BROKER_ADVANCED_SEARCH_RESULTS_SUCCESS:
        'BROKER_ADVANCED_SEARCH_RESULTS_SUCCESS',
    BROKER_ADVANCED_SEARCH_SAVE_FILTERS: 'BROKER_ADVANCED_SEARCH_SAVE_FILTERS',
};
